<div class="kn-br-consent-modal">
  <div class="kn-br-consent-modal__header">
    <!-- <h2 class="kn-br-consent-modal__title">Consent Management</h2> -->
  </div>

  <div class="kn-br-consent-modal__body">
     {{ 'consent.consentText' | cxTranslate }}

    <div class="kn-br-consent-modal__terms pt-4" #scrollTerms>
      <div class="form-check ml-4 custom-checkbox m-0 p-0 kn-br-consent-modal__checkbox cursor-pointer">
        <input 
          type="checkbox" 
          class="custom-control-input" 
          id="kn-br-consent-checkbox"
          [formControl]="consentControl" 
        />

        <label 
          class="custom-control-label kn-br-consent-modal__checkbox-label cursor-pointer" 
          for="kn-br-consent-checkbox">
          {{ 'consent.consentCheckbox' | cxTranslate }}
        </label>
      </div>
    </div>
  </div>

  <div class="kn-br-consent-modal__actions">
    <button class="btn btn-outline-secondary" type="button" (click)="decline()" [disabled]="isLoading">
      {{ 'consent.Close' | cxTranslate }}
    </button>

    <button 
      class="btn btn-primary" 
      type="button" 
      (click)="proceed()" 
      [disabled]="isLoading || consentControl.disabled || !consentControl.value">
      {{ 'consent.proceed' | cxTranslate }}
    </button>
  </div>
</div>